<template>
  <UikitList
    class="osk-products-sorting"
    :title="$t('components.filters.catalogFilters.catalogFiltersSorting.title')"
  >
    <UikitListItem
      v-for="(item, index) in sorting"
      :key="index"
      no-padding
    >
      <UikitFormRadio
        :model-value="modelValue"
        class="osk-products-sorting__item"
        name="radio"
        :value="item.code"
        :label="item.name"
        label-left
        justify-between
        icon-size="l"
        @update:model-value="handleChange"
      />
    </UikitListItem>
  </UikitList>
</template>

<script setup lang="ts">
import { ProductFilters, ProductSorting } from '~/restAPI/data-contracts';
import { AnalyticsEvents } from '~/types/analytics';

const { $addEvent } = useNuxtApp();

const props = defineProps<{
  modelValue: ProductSorting['code'],
  sorting?: ProductFilters['sorting']
  page?: string
}>();

const emits = defineEmits<{
  (e: 'update:modelValue', value: ProductSorting['code']): void,
}>();

function handleChange(value: ProductSorting['code']) {
  emits('update:modelValue', value);

  $addEvent(AnalyticsEvents.FiltersLinkClick, {
    chapter: 'sorting',
    id_chapter: value,
    page: props.page,
  });
}
</script>

<style lang="scss" scoped>
@import "~/assets/scss/settings/index";

.osk-products-sorting {
  &__item {
    height: 52px;
    padding: 0 16px;
  }
}
</style>
